import horizontalGalleryBreakpoint from '../constants/horizontal-gallery-breakpoint'
import { generateImagesId } from '../contexts/images'

function useControls() {
  return {
    /** The behavior is different for less than 991 px width as its an horizontal gallery **/
    handleDotClick: (id, isScroll = true) => {
      if (window.innerWidth > horizontalGalleryBreakpoint) {
        if (isScroll)
          // @ts-ignore
          document.getElementById(generateImagesId(id)).scrollIntoView({
            behavior: 'smooth'
          })
      } else {
        /** This div here is set in Images.js, is used in mobile views for the horizontal gallery **/
        // @ts-ignore
        const elm = document.getElementById('__ad-images-container')

        if (elm && elm.scrollLeft) {
          elm.scrollLeft = id * window.innerWidth
        }
      }
    }
  }
}

export default useControls
